<template>
  <div 
    class="zoom-container"
    @mousemove="onMouseMove"
    @mouseleave="onMouseLeave"
  >
    <img 
      :src="src" 
      alt="Zoomable" 
      ref="imageRef" 
      class="image" 
      :style="isDesktop ? imageStyles: {} "
    />
  </div>
</template>

<script setup>
  const {isDesktop} = useDevice();

  const props = defineProps({
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    zoomLevel: {
      type: Number,
      default: 1.5 
    },
  });

  const imageRef = ref(null);
  const isHovering = ref(false);
  const imageStyles = reactive({
    transform: 'scale(1)',
    transformOrigin: 'center center'
  });

  const onMouseMove = (event) => {
    const image = imageRef.value;
    if(image){
      const rect = image.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;
      const xPercent = (offsetX / rect.width) * 100;
      const yPercent = (offsetY / rect.height) * 100;
  
      isHovering.value = true;
      imageStyles.transform = `scale(${props.zoomLevel})`;
      imageStyles.transformOrigin = `${xPercent}% ${yPercent}%`;
    }
  };

  const onMouseLeave = () => {
    isHovering.value = false;
    imageStyles.transform = 'scale(1)';
    imageStyles.transformOrigin = 'center center';
  };
</script>

<style scoped>
.zoom-container {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 100%;
  height: auto;
  border: 1px solid #f5f5f5;
  border-radius: 8px;
}

.image {
  display: block;
  width: 100%;
  height: auto;
  /* transition: transform 0.2s ease, transform-origin 0.2s ease; */
}
.zoom-container:hover {
  cursor: zoom-in;
}
</style>
